import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppFeatureService {

  /****************** Variable declaration ******************/
  public applicationFeat = this.apiService.APPLICATION_FEAT;
  public appFeat = this.apiService.KPID_URL + this.applicationFeat.APP_FEAT;

  /**
   * Constructor
   * @param httpClient 
   * @param apiService 
   */
  constructor(private httpClient: HttpClient,
    private apiService: ApiService) { }

  /** get all features in access page */
  getAllFeatures(): Observable<any> {
    const url = this.appFeat + this.applicationFeat.APP_FEAT_ALL
    return this.httpClient.get(url)
  }
}
